import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _MatchListEdit;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import Footer from '../../../common/edit/components/Footer';
import MatchEdit from '../MatchEdit';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
var MatchListEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_MatchListEdit = /*#__PURE__*/function (_Component) {
  function MatchListEdit() {
    _classCallCheck(this, MatchListEdit);
    return _callSuper(this, MatchListEdit, arguments);
  }
  _inherits(MatchListEdit, _Component);
  return _createClass(MatchListEdit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        answerErrors = _this$props.answerErrors,
        editAnswer = _this$props.editAnswer,
        editQuestion = _this$props.editQuestion,
        matches = _this$props.matches,
        questionErrors = _this$props.questionErrors,
        disabled = _this$props.disabled,
        removeMatch = _this$props.removeMatch,
        createNewMatch = _this$props.createNewMatch,
        notifyScreenreader = _this$props.notifyScreenreader,
        styles = _this$props.styles;
      return jsx("div", {
        css: styles.matches
      }, jsx(Flex, {
        direction: "column",
        gap: "small"
      }, matches.map(function (match, idx) {
        return jsx(MatchEdit, {
          answerErrors: answerErrors(idx),
          editAnswer: editAnswer,
          editQuestion: editQuestion,
          disabled: disabled,
          hasOnlyOneMatch: matches.length === 1,
          key: match.questionId,
          questionId: match.questionId,
          questionBody: match.questionBody,
          answerBody: match.answerBody,
          questionErrors: questionErrors(idx),
          removeMatch: removeMatch,
          index: idx
        });
      })), !disabled ? jsx(Footer, {
        onCreateChoice: createNewMatch,
        buttonText: t('Question/Answer Pair'),
        screenReaderText: t('Add Question/Answer Pair'),
        notifyScreenreader: notifyScreenreader,
        "data-automation": "sdk-matching-add"
      }) : null);
    }
  }]);
}(Component), _defineProperty(_MatchListEdit, "displayName", 'MatchListEdit'), _defineProperty(_MatchListEdit, "componentId", "Quizzes".concat(_MatchListEdit.displayName)), _defineProperty(_MatchListEdit, "propTypes", {
  answerErrors: PropTypes.func.isRequired,
  createNewMatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  editAnswer: PropTypes.func.isRequired,
  editQuestion: PropTypes.func.isRequired,
  matches: PropTypes.arrayOf(PropTypes.shape({
    questionId: PropTypes.string,
    questionBody: PropTypes.string,
    answerBody: PropTypes.string
  })).isRequired,
  questionErrors: PropTypes.func.isRequired,
  removeMatch: PropTypes.func.isRequired,
  notifyScreenreader: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_MatchListEdit, "defaultProps", {
  disabled: false,
  notifyScreenreader: void 0
}), _MatchListEdit)) || _class);
export { MatchListEdit as default };